import { useAppDispatch } from 'shared/store/store'
import { addToasterMessage } from 'shared/store/toaster'

export const useToaster = () => {
  const appDispatch = useAppDispatch()

  const toast = (message: string, type: 'success' | 'danger') => {
    appDispatch(addToasterMessage({ text: message, type }))
  }

  return { toast }
}
